import { useState } from "react"

import type { GraphFileItem } from "@/api/models"

export function useFilePickerSelection() {
  const [selectedMap, setSelectedMap] = useState<Partial<Record<string, GraphFileItem>>>({})
  const [localFiles, setLocalFiles] = useState<File[]>([])

  const toggleSelection = (file: GraphFileItem) => {
    setSelectedMap((prev) => {
      const next = { ...prev }
      if (Object.prototype.hasOwnProperty.call(next, file.id)) {
        delete next[file.id]
      } else if (!file.isFolder) {
        next[file.id] = file
      }
      return next
    })
  }

  const selectAll = (files: GraphFileItem[]) => {
    const next: Record<string, GraphFileItem> = {}
    files.forEach((f) => {
      if (!f.isFolder) next[f.id] = f
    })
    setSelectedMap(next)
  }

  const clearSelection = () => {
    setSelectedMap({})
  }

  const addLocalFiles = (files: File[]) => {
    setLocalFiles((prev) => [...prev, ...files])
  }

  const removeLocalFile = (file: File) => {
    setLocalFiles((prev) => prev.filter((f) => f !== file))
  }

  const clearLocalFiles = () => {
    setLocalFiles([])
  }

  const getSelectedFiles = () => {
    return Object.values(selectedMap).filter(Boolean) as GraphFileItem[]
  }

  const getSelectedCount = () => {
    return Object.keys(selectedMap).length
  }

  return {
    // State
    selectedMap,
    localFiles,

    // Actions
    toggleSelection,
    selectAll,
    clearSelection,
    addLocalFiles,
    removeLocalFile,
    clearLocalFiles,

    // Computed
    getSelectedFiles,
    getSelectedCount,
  }
}
